export default "__VITE_ASSET__4c7e980c__"